import { render, staticRenderFns } from "./sectorSetup.vue?vue&type=template&id=d41c3296&scoped=true&"
import script from "./sectorSetup.vue?vue&type=script&lang=js&"
export * from "./sectorSetup.vue?vue&type=script&lang=js&"
import style0 from "./sectorSetup.vue?vue&type=style&index=0&id=d41c3296&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d41c3296",
  null
  
)

export default component.exports